<div>
  <div
    class="modal-table position-relative"
    [class.user]="isFromModal"
    infiniteScroll
    (scrolled)="onScroll()"
    [scrollWindow]="false"
  >
    <ng-container *ngIf="groups; else loading">
      <table class="standart-table" *ngIf="groups.length; else emptyGroups">
        <thead class="standart-table-header">
          <tr>
            <th style="width: 70%">name</th>
            <th style="width: 30%">group Id</th>
            <th style="width: 60px">
              <div class="d-flex" *ngIf="!isGroupsSelected">
                <label class="checkbox ml-auto">
                  <input
                    type="checkbox"
                    (change)="toggleAllGroups($event)"
                    [checked]="isAllGroupsChacked"
                  />
                </label>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let group of groups">
            <td class="no-wrap">{{ group.name }}</td>
            <td>{{ group.groupId }}</td>
            <td class="actions-cell">
              <div class="d-flex">
                <label class="checkbox ml-auto" *ngIf="!isGroupsSelected">
                  <input
                    type="checkbox"
                    (change)="onGroupCheckboxChange(group)"
                    [checked]="group.checked"
                  />
                </label>

                <a
                  href="javascript:void(0);"
                  class="standart-link-action red ml-auto"
                  [class.disabled]="disabled"
                  (click)="onGroupDelete(group)"
                  *ngIf="isGroupsSelected"
                >
                  <i class="fas fa-times-circle"></i>
                </a>
              </div>
            </td>
          </tr>

          <tr *ngIf="isGroupsLoading">
            <td colspan="3">
              <div class="d-flex w-100 h-100">
                <loader style="min-height: 180px"></loader>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>

  <div
    class="d-flex mt-3"
    *ngIf="
      checkedGroups &&
      checkedGroups.length > 0 &&
      !isGroupsSelected &&
      !isFromModal
    "
  >
    <button class="button w-134px ml-auto" (click)="onGroupSelected()">
      Apply
    </button>
  </div>
</div>

<ng-template #loading>
  <loader style="min-height: 180px"></loader>
</ng-template>

<ng-template #emptyGroups>
  <div
    class="d-flex justify-content-center align-items-center text-center"
    style="min-height: 180px"
  >
    <empty-state size="sm" title="No Group(s) Yet" [text]="emptyText">
    </empty-state>
  </div>
</ng-template>
